import './MyGoals.scss'

import { useContext, useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { navigateTo } from 'components/common/navigation'
import { getAuthenticatedUser } from 'components/auth'
import {
  ROUTE_CHECK_IN_SUMMARY,
  ROUTE_TODAY
} from 'components/common/helpers/Paths'
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import Loading from 'templates/Loading'
import Question from './Question'
import UserCheckinContext from 'components/common/contexts/UserCheckinContext'
import { saveUserCheckin } from 'components/common/api/Checkins'

export default function Assessment({ setReturnPath, setHeaderTitle }) {
  const history = useHistory()

  const {
    todayUserCheckin,
    setTodayUserCheckin,
    summaryUserCheckin,
    setSummaryUserCheckin
  } = useContext(UserCheckinContext)
  const [loading, setLoading] = useState(true)
  const user = getAuthenticatedUser()

  useEffect(() => {
    if (!todayUserCheckin || todayUserCheckin.length === 0) return

    setLoading(false)
  }, [todayUserCheckin])

  useEffect(() => {
    setReturnPath(ROUTE_TODAY)
    setHeaderTitle('Check-In')
  }, [setHeaderTitle, setReturnPath])

  const isValid = useMemo(() => {
    if (!todayUserCheckin || todayUserCheckin.length === 0) return false

    if (todayUserCheckin?.some(t => t.value === -1)) return false

    return true
  }, [todayUserCheckin])

  const handleUpdateTodayUserCheckin = async updatedTodayUserCheckin => {
    setLoading(true)

    const payload = updatedTodayUserCheckin.map(uc => ({
      measure_id: uc.measure_id,
      value: uc.value,
      checkin_date: uc.checkin_date
    }))

    await saveUserCheckin(payload)
    setSummaryUserCheckin([...summaryUserCheckin, ...updatedTodayUserCheckin])
    setLoading(false)
    navigateTo(ROUTE_CHECK_IN_SUMMARY, history)
  }

  return (
    <Loading isLoaded={loading}>
      <Container className='my-goals'>
        <Row className='mb-4'>
          <Col>
            <p className='my-goals__intro'>
              How are you feeling today, <strong>{user.display_name}</strong>?
            </p>
          </Col>
        </Row>

        {todayUserCheckin &&
          todayUserCheckin.map((userCheckin, index) => (
            <Question
              setValue={newValue => {
                const updatedTodayUserCheckin = todayUserCheckin.map(uc => {
                  if (uc.measure_id === newValue.measure_id) return newValue
                  return uc
                })
                setTodayUserCheckin(updatedTodayUserCheckin)
              }}
              key={index}
              userCheckin={userCheckin}
              index={userCheckin.measure_id}
            />
          ))}

        <Row>
          <Col>
            <Button
              disabled={!isValid}
              onClick={() => {
                handleUpdateTodayUserCheckin(todayUserCheckin)
              }}
              variant='primary'
              size='lg'
              className={`btn-block ${isValid ? '' : 'disabled'}`}
            >
              <Spinner
                animation='border'
                role='status'
                size='sm'
                style={{ margin: '0 10px 2px 0' }}
                hidden={!loading}
              >
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
              Save
            </Button>
          </Col>
        </Row>
      </Container>
    </Loading>
  )
}
